import React from "react";
import LikeFilled from "./LikeFilled";
import LikeOutline from "./LikeOutline";

export default ({ liked }) => {
  return liked ? <LikeFilled /> : <LikeOutline />;
};
